import React, { useState } from 'react';
import '../styles/Page.css';

function Page() {
    return (
        <div className='page'>
            <div>
                <img src="img/seoul2121_1.png" />
                <img src="img/seoul2121_2.png" />
                <img src="img/seoul2121_3.png" />
                
                <p style={{ textAlign: 'right' }}><i>Seoul 2121</i>, 2021. Web Application, Devleoped for SEOUL-EURYUNG-AESTHETIC 2021, Online.</p>
                <p>
                    SEOUL-EURYUNG-AESTHETIC 2021<br />
                    SEOUL AESTHETIC X EURYUNGCOMPANY<br />
                    HWI, Hyojae Kim, Dongkyun Vak, Jiyoung Wi, Yun Choi, Co-op, Tom & Huckleberry, Patrick Lowry, Abhijan Toto+Bela<br />
                    First Release 28 December 2021 Tue 9 pm<br />
                    Second Release TBC (January 2022)<br />
                    <br />
                    Organized by Hyojae Kim (SEOUL AESTHETIC)<br />
                    Directed by Alter Kim (EURYUNGCOMPANY)<br />
                    Web Development Nahee Kim<br />
                    Graphic Design Sohee Kim<br />
                    SEOUL 2121 3D Application Sima Kim<br />
                    Funded by Seoul, SFAC<br />
                </p>
                <br />
            </div>
        </div>

    )
}

export default Page;